module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD+SURBVHgB7ZZNDoMgEIWnP4suPYLeokuPoieo3XVXOEGPUI7Sm5QbtD2BfSQsGkQRpQYTvmQCw0zwBV6IRIlEYqVsXA2c82vbtg2mWU/LGyEYY2eawW6oiM1vGC6Iw0Cbqh3Lstw8AE1k76hXeiwgStoasJ5jeCJOKqWJbB31TH9M9jX81DKagUvIYriuxguczou6JzPKzF5CsFmFIdepRC6MFtv1qLUGvR8EoxBCwN3IhZF3TD3WzL4eqRFcR20WbaYea2bfqxH0J0J7ZBkh5PbIZHyFKF/kei4pINF4JJqXNQkxiUZI7x8ajKme5ZzCot6ewlaI5kQSicRq+QLWpkmcXh+VjQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico/ware-ico1.png
// module id = ZNiB
// module chunks = 2